import { render, staticRenderFns } from "./ModalProcessTabDocuments.vue?vue&type=template&id=7fb5e2a9&scoped=true"
import script from "./ModalProcessTabDocuments.vue?vue&type=script&lang=js"
export * from "./ModalProcessTabDocuments.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessTabDocuments.vue?vue&type=style&index=0&id=7fb5e2a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb5e2a9",
  null
  
)

export default component.exports